import { render, staticRenderFns } from "./CoinIcon.vue?vue&type=template&id=602e0d09&"
import script from "./CoinIcon.vue?vue&type=script&lang=ts&"
export * from "./CoinIcon.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('602e0d09', component.options)
    } else {
      api.reload('602e0d09', component.options)
    }
    module.hot.accept("./CoinIcon.vue?vue&type=template&id=602e0d09&", function () {
      api.rerender('602e0d09', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "frontend/components/icons/CoinIcon.vue"
export default component.exports